import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';

import './plugins/vuetify';
import './plugins/axios';
import './plugins/vee-validate';
import './plugins/google-maps';
import './plugins/moment';
import './plugins/timers';
import './plugins/vue-currency-filter';

import './filters';
import './components';
import './directives';

import router from './router';
import store from './store/index';

import App from './App.vue';

import '@fortawesome/fontawesome-pro/css/all.css';

Vue.config.productionTip = false;

// document.addEventListener("deviceready", () => {
//   window.open = cordova.InAppBrowser.open;
// });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
